import * as Dialog from '@radix-ui/react-dialog'

import styled, { css } from 'styled-components';
import { AiFillCloseCircle } from "react-icons/ai";
import { FaUserPlus } from "react-icons/fa";
import { IoMdAddCircleOutline } from "react-icons/io";

export const StyledTrigger = styled(Dialog.Trigger)`

    height: 50px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-bottom: 5px;
    align-items: center;
    text-align: center;
    border-radius: 10px;

    transition: opacity .3s;
    &:hover {
        opacity: .7;
        background-color: #F0E68C;
    }

`;

export const StyledOverlay = styled(Dialog.Overlay)`
    background-color: rgba(0, 0, 0, .15);
    position: fixed; 
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    
`;

export const StyledContent = styled(Dialog.Content)`
    
    position: fixed; 
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 200px;
    max-width: fit-content;
    max-height: 85vh;
    padding: 20;
    margin-top: -5vh;
    background-color: white;
    border-radius: 6px;

    border: 3px solid black;

    &:focus {
        outline: none;
    }

`;

export const StyledClose = styled(Dialog.Close)`
    position: absolute; 
    top: 0; 
    right: 0; 
    height: 50px;
    padding: 0.375rem;
    border: none;
    background-color: white;
    cursor: pointer;
`;

export const Header = styled.div`

    height: 50px;

    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 5px;
    border-bottom: 2px solid black;


`;

export const TitleHeader = styled.h1`

    margin-left: 8px;

`;

export const Form = styled.form`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: left;
    justify-content: space-between;
`;

export const SectionBox = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;

    font-size: 20px;
    font-weight: bold;

    justify-content: space-between;

    padding: 10px 5px 5px 10px;

    margin: 7px 0;

    > input {
        width: 95%;
        border-radius: 7px;
    }
`;

export const SendButtonContainer = styled.div`

    width: 100%;
    margin: 10px;

    display: flex;
    justify-content: center;

`;

export const SendButton = styled.button`
    margin: 4px;
`;

export const AiFillCloseCircleIcon = styled(AiFillCloseCircle)`
    width: 28px;
    height: 28px;
    border-radius: 8px;
`;

export const IoMdAddCircleOutlineIcon = styled(IoMdAddCircleOutline)`
    width: 28px;
    height: 28px;
    color: black;
`;